import React from 'react';

import { View } from 'react-native';

import {
  OPComponent,
  I18n,
  Utils,
  FormInput,
  IconButton,
  ArrowButton,
  Navigation,
  FormHelpers,
} from '../components';

import { THEME } from '../../constants/styles';

import { relationshipNameFromId } from './ui_helpers';

export default class PersonalForm extends OPComponent {
  constructor(props) {
    super(props);

    this._isUpdate = !!props.caseId;
    this._nameInputRef = React.createRef();
    this._patientNameInputRef = React.createRef();
    this._descriptionInputRef = React.createRef();
  }

  validate = () => {
    const fieldsToValidate = [
      this._nameInputRef.current,
      this._patientNameInputRef.current,
      this._descriptionInputRef.current,
    ];
    return FormHelpers.validateFields(fieldsToValidate);
  };

  goToRelationshipSelect = () => {
    Utils.trackEvent('Navigation', 'Load', 'Relationhip Sheet');
    Navigation.push(
      {
        screen: 'SelectRelationship',
        title: I18n.t('case.selectRelationship'),
        passProps: {
          setSelectedRole: (roleId) => {
            this.props.handleChangeValue({ roleId });
          },
          selectedRoleId: this.props.roleId,
        },
      },
      this.props.componentId
    );
  };

  goToTimeZoneSelect = () => {
    Utils.trackEvent('Navigation', 'Load', 'TimeZone Sheet');
    Navigation.push(
      {
        screen: 'EventTimeZones',
        title: I18n.t('calendar.timeZone'),
        passProps: {
          setSelected: (timeZone) => {
            this.props.handleChangeValue({ timeZone });
          },
          selectedId: this.props.timeZone,
        },
      },
      this.props.componentId
    );
  };

  render() {
    const isUpdate = this._isUpdate;
    const props = this.props;

    return (
      <View>
        {isUpdate && (
          <IconButton
            label={I18n.t('calendar.timeZone')}
            value={this.props.timeZone}
            imageSource={require('../../../resources/icon-time.png')}
            onPress={this.goToTimeZoneSelect}
            noTopBorder={false}
          />
        )}

        <View style={THEME.inputsContainer}>
          <FormInput
            ref={this._nameInputRef}
            required={true}
            value={this.props.name}
            label={I18n.t('case.caseName')}
            tipText={I18n.t('case.caseNameTip')}
            onChangeText={(text) => {
              this.props.handleChangeValue({ name: text });
            }}
            onSubmitEditing={() => {
              if (this.refs) {
                let nextRef = this.refs.patientNameInput || this.refs.descriptionInput;
                nextRef && nextRef.focus();
              }
            }}
          />

          {!isUpdate && (
            <FormInput
              ref={this._patientNameInputRef}
              required={true}
              value={this.props.patientName}
              label={I18n.t('patient.patientName')}
              tipText={I18n.t('case.patientNameTip')}
              requiredErrorText={`${I18n.t('case.patientNameTip')} Required`}
              onChangeText={(text) => {
                this.props.handleChangeValue({ patientName: text });
              }}
              onSubmitEditing={() => {
                this.refs && this.refs.descriptionInput && this.refs.descriptionInput.focus();
              }}
            />
          )}

          <FormInput
            ref={this._descriptionInputRef}
            required={true}
            value={this.props.description}
            label={I18n.t('case.description')}
            tipText={I18n.t('case.descriptionTip')}
            autoCapitalize="sentences"
            onChangeText={(text) => {
              this.props.handleChangeValue({ description: text });
            }}
          />

          {isUpdate && (
            <FormInput
              value={this.props.ailment}
              label={I18n.t('case.ailment')}
              autoCapitalize="words"
              onChangeText={(text) => {
                this.props.handleChangeValue({ ailment: text });
              }}
              onSubmitEditing={() => {}}
            />
          )}
        </View>

        {!isUpdate && (
          <ArrowButton
            label={I18n.t('case.relationshipToPatient')}
            value={relationshipNameFromId(this.props.roleId)}
            noTopBorder={false}
            onPress={this.goToRelationshipSelect}
          />
        )}
      </View>
    );
  }
}
